import { copyTextToClipboard } from "../../../../../AdminApi/commFunc";
import LineBtn from "../../../../Button/LineBtn";
import Flex from "../../../../DefaultStyles/Flex";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface Props extends DefaultModalCommonProps {
  userData: {
    uid: number;
    nickname: string;
    name: string;
  };
  accData: {
    email: string;
    pw: string;
  };
  svcid: number;
  resetEvent: () => void;
  registEvent: () => void;
  changeIdEvent?: () => void;
  changeExtraInfoEvent?: () => void;
}

export default function NetflixExtraAccModal({
  closeEvent,
  userData,
  accData,
  resetEvent,
  registEvent,
  changeIdEvent,
  changeExtraInfoEvent,
  svcid,
}: Props) {
  return (
    <DefaultModalLayout
      modalTitle="계정 정보 보기"
      closeEvent={closeEvent}
      confirmEvent={() => closeEvent()}
      cancelBtn={<></>}
      isMediumModal
    >
      <ModalRow>
        <ModalLabel>대상</ModalLabel>

        <ModalRowContentContainer>
          <ModalFixedBox>
            {userData.uid}_{userData.name}_{userData.nickname}
          </ModalFixedBox>
        </ModalRowContentContainer>
      </ModalRow>

      <ModalRow>
        <ModalLabel>아이디</ModalLabel>

        <ModalRowContentContainer>
          <ModalFixedBox>{accData.email}</ModalFixedBox>
          <LineBtn
            btnText="복사"
            // btnHeight={38}
            disabled={accData.email === ""}
            btnClickEvent={() =>
              copyTextToClipboard(
                accData.email,
                "이메일 아이디가 복사되었습니다."
              )
            }
          />
        </ModalRowContentContainer>
      </ModalRow>

      {/* <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>비밀번호</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <ModalFixedBox>
            {accData.pw === "" ? "등록 필요" : accData.pw}
          </ModalFixedBox>

          <LineBtn
            btnText="등록하기"
            btnClickEvent={() => {
              registEvent();
              closeEvent();
            }}
          />
          {svcid === 110 && (
            <LineBtn
              btnText="재설정하기"
              btnClickEvent={() => {
                resetEvent();
                closeEvent();
              }}
            />
          )}
        </ModalRowContentContainer>
      </ModalRow> */}
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>정보 변경하기</ModalLabel>
        <ModalRowContentContainer>
          {changeIdEvent && changeExtraInfoEvent && (
            <Flex justifyContent="space-between" margin="20px 0 0 0">
              <LineBtn
                btnText="아이디 정보 변경하기"
                btnClickEvent={() => {
                  changeIdEvent && changeIdEvent();
                  closeEvent();
                }}
              />
              

              <LineBtn
                btnText="추가 정보 변경하기"
                btnClickEvent={() => {
                  changeExtraInfoEvent && changeExtraInfoEvent();
                  closeEvent();
                }}
              />
            </Flex>
          )}
        </ModalRowContentContainer>
      </ModalRow>
    </DefaultModalLayout>
  );
}
